import { SentryEnvironment } from '@techniek-team/sentry-web';
import {
  EnvironmentApiConfig,
  EnvironmentModel,
} from '@lyceo/homi/shared/util-environment';
import { getApiConfig } from '@lyceo/shared/util-environment';
import { EnvFunc } from '@lyceo/shared/util';

const apiConfig: EnvironmentApiConfig = {
  homiApiUrl: 'https://api-homi.kube.techniek-team.nl',
};

export const environment: EnvironmentModel = {
  production: false,
  environment: SentryEnvironment.ACCEPTANCE,
  release: '4.2.0-story-xxx-fix-homi-url.1',
  sentryDsn:
    'https://898ee801f152feb893452fe7da6d2512@errors.techniek-team.nl/162',
  gitlabFeatureFlags: {
    url: 'https://lizzie-unleash.kube.techniek-team.nl/proxy',
    clientKey: 'D0Dfv8dGpqYHSezvYLezCU31tEyxBHmu',
    environment: 'acceptance',
  },
  authConfig: {
    responseType: 'code',
    scope: 'openid profile email offline_access',
    sessionChecksEnabled: false,
    clearHashAfterLogin: true,
    nonceStateSeparator: 'semicolon',
    openUri: EnvFunc.openUri,
  },
  loginDomain: 'homi-nu',
  issuerUrl: 'https://login.kube.techniek-team.nl',
  ...getApiConfig(apiConfig),
};
